import {
  getUser,
  invitationList,
  groupList,
  editMeInfo,
  addInvitation,
  delInvitation,
  editInvitation
} from '@/api/basicInfo'
import checkPermission from '@/utils/permission'
import upperFirst from "lodash/upperFirst";
import store from '@/store/index'

const state = {
  namespaced: true,
  state: {
    userInfo: {},
    searchOperatorInfo: {
      role: 'OPERATOR',
      status: 'ALL',
      searchValue: '',
      page: 1,
      size: 15,
    },
    otherTotal: {
      available: 0,
      total: 0,
      total_content: 0,
      total_invitation: 0
    },
    operatorTotal: 0,
    operatorList: [],
    tableLoading: false,
    searchGroupInfo: {
      // page: 1,
      // size: 15,
      searchValue: ''
    },
    groupList: [],
    terminalLoading: false,
    profileLoading: false,
    operatorGroupList: [],
    pageNameStore: 'Profile'
  },
  mutations: {
    SET_INIT_SEARCH(state) {
      state.searchOperatorInfo = {
        role: 'OPERATOR',
        status: 'ALL',
        searchValue: '',
        page: 1,
        size: 20,
      }
    },
    SET_INIT_GROUP_INFO(state) {
      state.searchGroupInfo = {
        // page: 1,
        // size: 15,
        searchValue: ''
      }
    },
    SET_GROUP_LIST(state, list) {
      state.groupList = list
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info || {}
    },
    SET_SEARCH_OPERATOR_INFO(state, obj) {
      state.searchOperatorInfo = obj
    },
    SET_SEARCH_GROUP_INFO(state, obj) {
      state.searchGroupInfo = obj
    }, 
    SET_PAGE_NAME(state, name) {
      state.pageNameStore = name
    },
    SET_OPERATOR_LIST(state, data) {
      // data.members && data.members.forEach(item => {
      //   item.commandDisabled = (!checkPermission(['admin']) || item.rank === 0 || !item.id)
      // })
      // console.log('operatorList',state.operatorList)
      state.operatorList = data.members || []
      state.operatorGroupList = data.group || {}
      state.otherTotal.available = data.available || 0
      state.otherTotal.total = data.total || 0
      state.otherTotal.total_content = data.total_content || 0
      state.otherTotal.total_invitation = data.total_invitation || 0
      state.otherTotal.members_total =  data.members_total || 0
    },
    SET_TABLE_LOADING(state, truth) {
      state.tableLoading = truth
    },
    SET_TERMINAL_LOADING(state, truth) {
      state.terminalLoading = truth
    },
    SET_PROFILE_LOADING(state, truth) {
      state.profileLoading = truth
    }
  },
  actions: {
    setPageName({ commit }, data = 'Profile') {
      console.log(1231231)
      commit('SET_PAGE_NAME', data)
    },
    getUser({commit}) {
      getUser().then(res => {
        let data = res.res.data
        if (data.code == 200) {
          commit('SET_USER_INFO', data.data)
          commit('SET_PROFILE_LOADING', false)
        }
      })
    },
    getOperatorList({commit, state, dispatch}) {
      let params = JSON.parse(JSON.stringify(state.searchOperatorInfo))
      params.page > 0 ? params.page-- : ''
      invitationList(params).then(res => {
        let data = res.res.data
        console.log(data)
        if (params.page > 0 && data && data.data && data.data.members.length == 0) {
          dispatch('setStatusSearch', {
            name: 'page',
            value: params.page
          })
          dispatch('getOperatorList')
          return
        }
        if (data && data.code == 200) {
          console.log(data)
          let proxyData = data.data
          const userId = store.state.user.userId
          let accessOperator = store.state.user.usersAuthorities['fleet:accountOperation:accessOperator']
          proxyData.members && proxyData.members.forEach(item => {
            if(!item.id) {
              item.commandDisabled = true
            } else if (userId === item.id) {
              item.commandDisabled = false
            } else if (checkPermission(['admin']) && item.rank === 0) {
              item.commandDisabled = false
            } else  if (accessOperator == 'true') {
              if (!checkPermission(['admin']) && item.rank === 0) {
                item.commandDisabled = true
              } else {
                item.commandDisabled = false
              }
            } else {
              item.commandDisabled = true
              item.noPermission = true
            }
            // item.commandDisabled = (!checkPermission(['admin']) || item.rank === 0 || !item.id)
            console.log('permiss', item.commandDisabled)
            // if (!item.commandDisabled) {
            //   if (accessOperator == 'false') {
            //     item.commandDisabled = true
            //     item.noPermission = true
            //   }
            // }
            let value
            if (item.status == 'active') {
              value = 3
            } else if (item.status == 'inactive') {
              value = 4
            } else if (item.status == 'pending') {
              value = 1
            }
            item.status = {
              label: upperFirst(item.status),
              value: value,
            }
          })
          commit('SET_OPERATOR_LIST', proxyData)
        }
        dispatch('setTableLoading', false)
      }, (error) => {
        console.log(error)
      })
    },
    setStatusSearch({state, commit}, data) {
      if (data) {
        const field = data.name
        const obj = Object.assign({}, state.searchOperatorInfo)
        obj[field] = data.value
        commit('SET_SEARCH_OPERATOR_INFO', obj)
      }
    },
    setGroupSearch({state, commit}, data) {
      if (data) {
        const field = data.name
        const obj = Object.assign({}, state.searchGroupInfo)
        obj[field] = data.value
        commit('SET_SEARCH_GROUP_INFO', obj)
      }
    },

    setTableLoading({commit}, truth) {
      commit('SET_TABLE_LOADING', truth)
    },
    initGroupSearch({commit}) {
      commit('SET_INIT_GROUP_INFO')
    },
    initSearch({ commit, dispatch }) {
      dispatch('setTableLoading', true)
      commit('SET_INIT_SEARCH')
      dispatch('getOperatorList')
    },
    getGroupList({ commit, state, dispatch }) {
      let params = JSON.parse(JSON.stringify(state.searchGroupInfo))
      groupList(params).then(res => {
        let data = res.res.data
        if (data && data.code == 200) {
          let list = data.data || []
          let terminal = store.state.user.usersAuthorities['fleet:companySetting:terminal']
          list.forEach(item => {
            if (terminal == 'view') {
              item.commandDisabled = true
              item.noPermission = true
            }
          })
          commit('SET_GROUP_LIST', list)
        }
        dispatch('setTerminalLoading', false)
      })
    },
    setTerminalLoading({commit}, truth) {
      commit('SET_TERMINAL_LOADING', truth)
    },
    saveProfileInfo({ dispatch },data) {
      const params = JSON.parse(JSON.stringify(data))
      params.confirmation = false
      editMeInfo(params).then((res) => {
        console.log(res)
        dispatch('user/getUser', null, { root: true })
      }).finally(() => {
        dispatch('getUser')
      })
    },
    setProfileLoading({ commit }, truth) {
      commit('SET_PROFILE_LOADING', truth)
    },
    addInvitation({ dispatch }, data) {
      return new Promise((resolve)  => {
        addInvitation(data).then(() => {
          dispatch('getOperatorList')
        }).finally(() => {
          resolve()
        })
      })
    },
    delInvitation({ dispatch }, data) {
     return new Promise((resolve, reject) =>
        delInvitation(data).then((res) => {
          dispatch('setTableLoading', true)
          dispatch('getOperatorList')
          resolve(res)
          }).catch((error) => {
          reject(error)
        }))
    },
    editInvitation({ dispatch }, data) {
      return new Promise((resolve, reject) =>
        editInvitation(data).then(res => {
          dispatch('setTableLoading', true)
          dispatch('getOperatorList')
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      )
    }
  },
  modules: {
  },
  getters: {
    userInfo: state => state.userInfo,
    operatorList: state => state.operatorList,
    tableLoading: state => state.tableLoading,
    searchOperatorInfo: state => state.searchOperatorInfo,
    operatorTotal: state => state.operatorTotal,
    otherTotal: state => state.otherTotal,
    groupList: state => state.groupList,
    terminalLoading: state => state.terminalLoading,
    profileLoading: state => state.profileLoading,
    operatorGroupList: state => state.operatorGroupList,
    pageNameStore: state => state.pageNameStore,
  }
}

export default state
